import { GetterTree } from "vuex";
import { ISupplierState } from "./state";
import { ISupplier } from "@/models";

export const getters: GetterTree<ISupplierState, any> = {
    getSuppliers: (state) => (): ISupplier[] => {
        return state.suppliers;
    },

    getSupplierById: (state) => (supllierId: number): ISupplier => {
        return state.suppliers.find(x => x.supplierId === supllierId);
    },
};
